export default [
  {codigo: 'AGRICULTURA', value: 'Agricultura'},
  {codigo: 'PECUARIA', value: 'Pecuária'},
  {codigo: 'SILVICULTURA', value: 'Silvicultura'},
  {codigo: 'SERVIDAO_AMBIENTAL', value: 'Servidão Ambiental'},
  {codigo: 'SISTEMAS_AGROFLORESTAIS', value: 'Sistema Agroflorestais'},
  {codigo: 'OUTRO', value: 'Outro'}
]



// WEBPACK FOOTER //
// ./src/store/modules/centralInteressado/TiposAtivadades.js